let cachedClientMac: string | null | undefined

export const getClientMac = async (): Promise<string | undefined> => {
  if (cachedClientMac !== undefined) return cachedClientMac || undefined
  const client = (window as any).zhongshengClient
  if (!client?.getMac) {
    cachedClientMac = null
    return undefined
  }
  try {
    const mac = await client.getMac()
    cachedClientMac = typeof mac === 'string' && mac.trim() ? mac.trim() : null
  } catch {
    cachedClientMac = null
  }
  return cachedClientMac || undefined
}
